module.exports = "<div class=\"columns is-centered\">\r\n    <div class=\"column is-narrow has-text-centered\">\r\n        <mat-spinner></mat-spinner>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-general/components/page-loading/page-loading.component.html
// module id = ./src/app/ui-general/components/page-loading/page-loading.component.html
// module chunks = main